import { useEffect } from "react";
import { getWells } from "../services/api-server/wells";
import { useWellStore } from "../stores/wellStore";
import { TWellData } from "../types/well";

const getWellIdFromPath = (pathname: string): string | null => {
	const match = pathname.match(/^\/wells\/([^/]+)/);
	const wellId = match ? match[1] : null;
	return wellId;
};

function useInitWell(currentTenantKey: string | null) {
	const { well, setWell } = useWellStore();
	const wellId = getWellIdFromPath(location.pathname);

	useEffect(() => {
		if (!currentTenantKey) return;
		if (!wellId) {
			setWell({} as TWellData);
			return;
		}
		if (!well || well._id !== wellId) {
			getWells(currentTenantKey, {
				_id: wellId,
			}).then((well: any) => {
				if (well && well.length > 0) {
					setWell(well[0]);
				}
			});
		}
	}, [wellId, currentTenantKey]);
}

export default useInitWell;
